import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AttendanceScreen from './components/AttendanceScreen';
import AttendanceHistoryScreen from './components/AttendanceHistoryScreen';
import SettingsScreen from './components/SettingsScreen';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<AttendanceScreen />} />
          <Route path="/history" element={<AttendanceHistoryScreen />} />
          <Route path="/settings" element={<SettingsScreen />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App; 